// extracted by mini-css-extract-plugin
module.exports = {"svg":"scroll-arrow-module--svg--3jl8b","svg__marquee":"scroll-arrow-module--svg__marquee--1rLaU","rotate":"scroll-arrow-module--rotate--3u5IP"};